
import { USER_GETTERS } from "@/store/user/getters";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    UploadContentDialog: () =>
      import("@/components/dialogs/UploadContentDialog.vue"),
  },
})
export default class Index extends Vue {
  get isAdmin() {
    const user = this.$store.getters[USER_GETTERS.ACTING_USER];
    return user.type === "ADMIN";
  }
}
